import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('please_open_the_approva_yourself_as_a_requester'),
    organisations: defineMessage('organisations_1'),
    buttonText: defineMessage('go_to_workflow'),
};
